var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M13 4.5v7.244A2.258 2.258 0 0 1 10.744 14H5.256A2.255 2.255 0 0 1 3 11.744V4.5h-.25a.75.75 0 0 1 0-1.5h10.5a.75.75 0 1 1 0 1.5H13zm-8.5 0v7.244c0 .419.337.756.756.756h5.488c.416 0 .756-.34.756-.756V4.5h-7zM10 10c0 .414-.21.75-.625.75-.414 0-.625-.336-.625-.75V7c0-.414.21-.75.625-.75.414 0 .625.336.625.75v3zm-2.75 0c0 .414-.21.75-.625.75-.414 0-.625-.336-.625-.75V7c0-.414.21-.75.625-.75.414 0 .625.336.625.75v3zM6.5 1h3a1 1 0 0 1 1 1v.5h-5V2a1 1 0 0 1 1-1z" })
  );
});